import { cloneDeep } from 'lodash-es';
import React, { useEffect, useState } from 'react';

import { Col } from '~/src/dash/components/layout';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';

interface IDropdownValueProps {
  list: IMenuList;
  menuTitle: string;
  singularTitle: string;
  handleIDSelectionAccept: (key: string, list: IMenuList) => void;
  activeFields: Record<string, boolean>;
}

export const DropdownValues = ({
  menuTitle,
  list,
  handleIDSelectionAccept,
  activeFields,
}: IDropdownValueProps) => {
  const [listState, setListState] = useState(list);
  const originalList = list;

  const getSelectedFilters = (listState: IMenuList) => {
    const result = {} as IMenuList;
    Object.values(listState).forEach((item) => {
      if (item.selected) {
        result[item.ID] = item;
      }
    });
    return result;
  };

  useEffect(() => {
    // if checkbox is unchecked, reset selected channel list
    if (activeFields[menuTitle] === false) {
      setListState(cloneDeep(originalList));
    }
  }, [activeFields]);

  return (
    <Col
      style={{
        paddingTop: '8px',
        cursor: 'pointer',
      }}
    >
      <MaterialSearchDropdownMulti
        getValueFromSearchElement={(src: IListItem) => src.title}
        selectAll={true}
        menuTitle={`${menuTitle} to add to Channel Groups`}
        list={listState}
        onChange={(list: IMenuList) => setListState(list)}
        handleMenuAcceptClick={() =>
          handleIDSelectionAccept(menuTitle, getSelectedFilters(listState))
        }
        showPrefixID={true}
        width='400px'
      />
    </Col>
  );
};
